"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeBorderColorShorthand = exports.openBorderColorShorthand = exports.closeBorderWidthShorthand = exports.openBorderWidthShorthand = exports.closeBorderStyleShorthand = exports.openBorderStyleShorthand = exports.closeBorderLeftShorthand = exports.openBorderLeftShorthand = exports.closeBorderBottomShorthand = exports.openBorderBottomShorthand = exports.closeBorderRightShorthand = exports.openBorderRightShorthand = exports.closeBorderTopShorthand = exports.openBorderTopShorthand = exports.closeBorderShorthand = exports.openBorderShorthandShallow = exports.openBorderShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var shorthand_parser_errors_1 = require("../shorthand-parser-errors");
var borderShorthandPart = function (prop, dataType, openedProps) { return ({
    prop: prop,
    dataType: dataType,
    partOpener: openedProps ? (0, shorthand_parser_utils_1.edgesShorthandOpener)(prop) : undefined,
    openedProps: openedProps,
}); };
var getBorderStyleShorthandPart = function () {
    return borderShorthandPart('border-style', css_data_types_1.lineStyleDataType, [
        'border-top-style',
        'border-right-style',
        'border-bottom-style',
        'border-left-style',
    ]);
};
var getBorderWidthShorthandPart = function () {
    return borderShorthandPart('border-width', css_data_types_1.lineWidthDataType, [
        'border-top-width',
        'border-right-width',
        'border-bottom-width',
        'border-left-width',
    ]);
};
var getBorderColorShorthandPart = function () {
    return borderShorthandPart('border-color', css_data_types_1.colorDataType, [
        'border-top-color',
        'border-right-color',
        'border-bottom-color',
        'border-left-color',
    ]);
};
// border
var openBorderShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'border',
        parts: [
            getBorderStyleShorthandPart(),
            getBorderWidthShorthandPart(),
            getBorderColorShorthandPart(),
        ],
        shorthandOpener: function (astNodes, api, parts, shallow) {
            return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts, { shallow: shallow })(astNodes, api);
        },
    });
};
exports.openBorderShorthand = openBorderShorthand;
var openBorderShorthandShallow = function () {
    var borderShallowOpener = function (shortHand, api) {
        return (0, exports.openBorderShorthand)()(shortHand, api, true);
    };
    return borderShallowOpener;
};
exports.openBorderShorthandShallow = openBorderShorthandShallow;
var closeBorderShorthand = function () {
    return function (opened, api, detachExpression, shallow) {
        if (shallow) {
            var borderShallowCloser = (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " ", " ", ""], ["", " ", " ", ""])), 'border-style', 'border-width', 'border-color'));
            return borderShallowCloser(opened, api, detachExpression);
        }
        var borderClosedTop = (0, exports.closeBorderTopShorthand)()(opened, api, detachExpression);
        var borderClosedTopValue = (0, shorthand_parser_utils_1.getOpenedNodeValue)(borderClosedTop, api);
        if ((0, shorthand_parser_utils_1.getOpenedNodeValue)((0, exports.closeBorderRightShorthand)()(opened, api, detachExpression), api) !==
            borderClosedTopValue ||
            (0, shorthand_parser_utils_1.getOpenedNodeValue)((0, exports.closeBorderBottomShorthand)()(opened, api, detachExpression), api) !==
                borderClosedTopValue ||
            (0, shorthand_parser_utils_1.getOpenedNodeValue)((0, exports.closeBorderLeftShorthand)()(opened, api, detachExpression), api) !==
                borderClosedTopValue) {
            throw new shorthand_parser_errors_1.CannotCloseBorderError();
        }
        return borderClosedTop;
    };
};
exports.closeBorderShorthand = closeBorderShorthand;
var borderEdgeProp = function (edge, item) { return "border-".concat(edge, "-").concat(item); };
var borderEdgeShorthandOpener = function (edge) {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: "border-".concat(edge),
        parts: [
            borderShorthandPart(borderEdgeProp(edge, 'style'), css_data_types_1.lineStyleDataType),
            borderShorthandPart(borderEdgeProp(edge, 'width'), css_data_types_1.lineWidthDataType),
            borderShorthandPart(borderEdgeProp(edge, 'color'), css_data_types_1.colorDataType),
        ],
        shorthandOpener: function (astNodes, api, parts) {
            return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts, { shallow: true })(astNodes, api);
        },
    });
};
// border-top
var openBorderTopShorthand = function () {
    return borderEdgeShorthandOpener('top');
};
exports.openBorderTopShorthand = openBorderTopShorthand;
var closeBorderTopShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["", " ", " ", ""], ["", " ", " ", ""])), borderEdgeProp('top', 'style'), borderEdgeProp('top', 'width'), borderEdgeProp('top', 'color')));
};
exports.closeBorderTopShorthand = closeBorderTopShorthand;
// border-right
var openBorderRightShorthand = function () {
    return borderEdgeShorthandOpener('right');
};
exports.openBorderRightShorthand = openBorderRightShorthand;
var closeBorderRightShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["", " ", " ", ""], ["", " ", " ", ""])), borderEdgeProp('right', 'style'), borderEdgeProp('right', 'width'), borderEdgeProp('right', 'color')));
};
exports.closeBorderRightShorthand = closeBorderRightShorthand;
// border-bottom
var openBorderBottomShorthand = function () {
    return borderEdgeShorthandOpener('bottom');
};
exports.openBorderBottomShorthand = openBorderBottomShorthand;
var closeBorderBottomShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["", " ", " ", ""], ["", " ", " ", ""])), borderEdgeProp('bottom', 'style'), borderEdgeProp('bottom', 'width'), borderEdgeProp('bottom', 'color')));
};
exports.closeBorderBottomShorthand = closeBorderBottomShorthand;
// border-left
var openBorderLeftShorthand = function () {
    return borderEdgeShorthandOpener('left');
};
exports.openBorderLeftShorthand = openBorderLeftShorthand;
var closeBorderLeftShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["", " ", " ", ""], ["", " ", " ", ""])), borderEdgeProp('left', 'style'), borderEdgeProp('left', 'width'), borderEdgeProp('left', 'color')));
};
exports.closeBorderLeftShorthand = closeBorderLeftShorthand;
// border-style
var openBorderStyleShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpenerFromPart)(getBorderStyleShorthandPart());
};
exports.openBorderStyleShorthand = openBorderStyleShorthand;
var closeBorderStyleShorthand = function () {
    return (0, shorthand_parser_utils_1.edgesShorthandCloser)('border-style');
};
exports.closeBorderStyleShorthand = closeBorderStyleShorthand;
// border-width
var openBorderWidthShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpenerFromPart)(getBorderWidthShorthandPart());
};
exports.openBorderWidthShorthand = openBorderWidthShorthand;
var closeBorderWidthShorthand = function () {
    return (0, shorthand_parser_utils_1.edgesShorthandCloser)('border-width');
};
exports.closeBorderWidthShorthand = closeBorderWidthShorthand;
// border-color
var openBorderColorShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpenerFromPart)(getBorderColorShorthandPart());
};
exports.openBorderColorShorthand = openBorderColorShorthand;
var closeBorderColorShorthand = function () {
    return (0, shorthand_parser_utils_1.edgesShorthandCloser)('border-color');
};
exports.closeBorderColorShorthand = closeBorderColorShorthand;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=border-shorthand.js.map